import { createContext, useContext } from "react"

import { log } from "../utils"
import { ThemeName } from "./themes"

interface ContextValue {
  themeName: ThemeName
  setThemeName: (name: ThemeName) => void
}

export const ThemeContext = createContext<ContextValue>({
  themeName: ThemeName.Dark,
  setThemeName: () => log.error("Missing StorageThemeProvider"),
})

export const useTheme = () => {
  const { themeName, setThemeName } = useContext(ThemeContext)
  const toggleTheme = () =>
    setThemeName(
      themeName === ThemeName.Dark ? ThemeName.Light : ThemeName.Dark,
    )

  return { themeName, setTheme: setThemeName, toggleTheme }
}
